export default "__VITE_ASSET__CyZY5uKM__"